module.exports = __webpack_public_path__ + "static/media/checkboxWhite.ce33b318.svg";